<template>
  <router-view/>
</template>

<script>
var VueScrollTo = require('vue-scrollto');
export default {
  watch: {
    $route() {
      VueScrollTo.scrollTo('#app', 0)
    }
  }
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body {
    line-height: 1.6;
    font-feature-settings: "palt";
    font-family: source-han-sans-cjk-ja, sans-serif;
}
h1 {
  a {
    color: #000;
    text-decoration: none;
    &:hover {
    }
  }
}
html {
  font-size: 16px;
}

h1 {
  font-size: 1.25rem;
}
#app {
  text-align: center;
}

#nav {
  width: 100%;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

  img {
    max-width: 100%;
  }
</style>
